import React from 'react';

// Byte-copy of the main app's Logo (docs/EXECUTION_PLAN.md: components/Logo.js
// QueryState.js byte-copies) - public/logo.png and logo.svg were carried over
// to this client scaffold in P2 stage 1 alongside it.
const Logo = ({
  className = '',
  size = 'default',
  variant = 'full', // 'full', 'icon', 'text'
  onClick = null
}) => {
  const sizeClasses = {
    small: 'h-[18px]',      // h-6 (24px) * 0.75 = 18px
    default: 'h-6',           // h-8 (32px) * 0.75 = 24px
    large: 'h-9',            // h-12 (48px) * 0.75 = 36px
    xlarge: 'h-12'           // h-16 (64px) * 0.75 = 48px
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const logoElement = (
    <div
      className={`inline-flex items-center justify-center ${className}`}
      onClick={handleClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      {variant === 'icon' && (
        <img
          src="/logo.svg"
          alt="Standardly"
          className={`${sizeClasses[size]} w-auto object-contain`}
        />
      )}
      {variant === 'text' && (
        <span className={`font-heading font-bold text-primary-600 ${sizeClasses[size] === 'h-6' ? 'text-lg' : sizeClasses[size] === 'h-8' ? 'text-xl' : sizeClasses[size] === 'h-12' ? 'text-2xl' : 'text-3xl'}`}>
          Standardly
        </span>
      )}
      {variant === 'full' && (
        <img
          src="/logo.png"
          alt="Standardly"
          className={`${sizeClasses[size]} w-auto object-contain`}
        />
      )}
    </div>
  );

  return logoElement;
};

export default Logo;
